document.addEventListener('DOMContentLoaded', () => {

    var mobileItemTrigger = document.querySelectorAll('.js-mm-dropdown');

    mobileItemTrigger.forEach(function (el) {
        el.addEventListener('click', function () {
            if (el.closest('.cm-draw-menu__item').classList.contains('_is-open')) {
                el.closest('.cm-draw-menu__item').classList.remove('_is-open');
            } else {
                el.closest('.cm-draw-menu__item').classList.add('_is-open');
            }
        })
    })

    // document.body.addEventListener('click', e => {
    //     const openLink = e.target.closest('.js-mm-dropdown');
    //     if (openLink) {
    //         e.preventDefault();
    //         const dropdown = openLink.parentElement.querySelector(':scope > .cm-draw-menu-dropdown');
    //         if (dropdown) dropdown.classList.add('open');
    //         return;
    //     }
    //
    //     const closeBtn = e.target.closest('.js-dropdown-close');
    //     if (closeBtn) {
    //         const dropdown = closeBtn.closest('.cm-draw-menu-dropdown');
    //         if (dropdown) dropdown.classList.remove('open');
    //     }
    // });
});

document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('.js-mobile-drawer');
    if (!drawer) return;

    const THRESHOLD = 150;

    window.addEventListener('scroll', () => {
        if (window.scrollY > THRESHOLD) {
            drawer.classList.add('_is-scrolled');
        } else {
            drawer.classList.remove('_is-scrolled');
        }
    });
});

